import * as React from 'react';

function SvgLandlordCountry(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.647 8.155h5.266l-2.46 2.383c-.294.284-.459.67-.459 1.074v3.915l-1.91.029c-1.868.022-3.025.014-3.471-.023l-.096-.01c-.26-.035-2.212-.344-2.303-1.638l-.004-.166c-.001-.387.063-2.268 1.337-3.659l.078-.09c.339-.376 1.78-1.815 4.022-1.815zm7.33.73l.039.038 2.55 2.639c.137.14.212.326.212.519v3.446h-2.32V13.65h-1.94v1.876H9.162v-3.45c0-.19.074-.374.207-.514l2.509-2.636a.794.794 0 011.1-.041zM7.25 0c2.141 0 3.834 1.647 3.834 3.73 0 1.995-1.693 3.73-3.834 3.73-2.142 0-3.835-1.646-3.835-3.73C3.414 1.647 5.107 0 7.25 0z"
        fill="#000"
        fillOpacity={0.65}
      />
    </svg>
  );
}

export default SvgLandlordCountry;
